import React, { useRef, useEffect, useState } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'

import Logo from '../../assets/images/eco-logo.png'
import userIcon from '../../assets/images/user-icon.png'
import { motion } from 'framer-motion'
import { Container, Row } from 'reactstrap'
import { useSelector } from 'react-redux'

import useAuth from '../../custom-hooks/useAuth'
import { signOut } from 'firebase/auth'
import { auth } from '../../firebase.config'
import { toast } from 'react-toastify'

import './header.css'

const nav__link = [
  { path: 'home', display: 'Home' },
  { path: 'shop', display: 'Shop' },
  { path: 'cart', display: 'Cart' },
]

const Header = () => {
  const [isActive, setIsActive] = useState(false)
  const headerRef = useRef(null)
  const menuRef = useRef(null)
  const totalQuantity = useSelector((state) => state.cart.totalQuantity)
  const profileActionRef = useRef(null)
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const stickyHeaderFunc = () => {
    window.addEventListener('scroll', () => {
      if (
        document.body.scrollTop > 80 ||
        document.documentElement.scrollTop > 80
      ) {
        headerRef.current.classList.add('sticky__header')
      } else {
        headerRef.current.classList.remove('sticky__header')
      }
    })
  }

  const logout = () => {
    signOut(auth)
      .then(() => {
        toast('logged out')
        navigate('/home')
      })
      .catch((err) => {
        toast('logged out', err.message)
      })
  }
  useEffect(() => {
    stickyHeaderFunc()

    return () => window.removeEventListener('scroll', stickyHeaderFunc)
  })

  const handleClick = (event) => {
    // 👇️ toggle isActive state on click
    setIsActive((current) => !current)
  }

  const menuToggle = () => menuRef.current.classList.toggle('active__menu')
  const toggleProfileActions = (e) => {
    profileActionRef.current.classList.toggle('show__profileActions')
  }

  const navigatoToCart = () => {
    navigate('/cart')
  }

  return (
    <header className="header" ref={headerRef}>
      <Container>
        <Row>
          <div className="nav__wrapper">
            <div className="logo">
              <img src={Logo} alt="" />
              <div>
                <h1>Shopping</h1>
              </div>
            </div>
            <div className="navgation" ref={menuRef} onClick={menuToggle}>
              <motion.ul whileTap={{ scale: 1.1 }} className="menu">
                {nav__link.map((item, index) => (
                  <li className="nav__item" key={index}>
                    <NavLink
                      to={item.path}
                      className={(navClass) =>
                        navClass.isActive ? 'nav__active' : ''
                      }
                    >
                      {item.display}
                    </NavLink>
                  </li>
                ))}
              </motion.ul>
            </div>

            <div className="nav__icons">
              <span className="fav__icon">
                <i className="ri-heart-line"></i>
                <span className="badge"></span>
              </span>
              <span className="cart__icon" onClick={navigatoToCart}>
                <i className="ri-shopping-bag-line"></i>
                <span className="badge">{totalQuantity}</span>
              </span>
              <div className="profile">
                <motion.img
                  whileTap={{ scale: 1.2 }}
                  src={currentUser ? currentUser.photoURL : userIcon}
                  alt=""
                  onClick={handleClick}
                  className={isActive ? 'active__menu' : 'active__menu'}
                />
                <div
                  className="profile__actions"
                  ref={profileActionRef}
                  onClick={handleClick}
                >
                  {currentUser ? (
                    <span onClick={logout}>Logout</span>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center flex-column">
                      <Link to="/signup">Signup</Link>
                      <Link to="/login">Login</Link>
                      <Link to="/dashboard">Dashboard</Link>
                    </div>
                  )}
                </div>
              </div>
              <div className="mobile__menu">
                <span onClick={menuToggle}>
                  <i class="ri-menu-line"></i>
                </span>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </header>
  )
}

export default Header
